import {
  classes,
  addClassToElement,
  removeClassToElement,
  hasClassElement
} from '@jspartials/class-list-utils';

import {
  setHtmlScrollable,
  setHtmlUnscrollable
} from '@jspartials/general-utils';

import { customEvent } from '@jspartials/general-utils';

const selector = {
  menuLink: '.js-menu-link',
  headerContent: '.js-header__content'
};

const closeSearcherFromMenu = new CustomEvent(
  customEvent.closeSearcherFromMenu
);

export default class Menu {
  constructor(
    wrapperSelector,
    contentElementSelector,
    wrapperCategoriesElementSelector,
    buttonGenderMobileSelector
  ) {
    this.wrapperElement = document.querySelector(wrapperSelector);
    this.contentElement = document.querySelector(contentElementSelector);
    this.wrapperCategoriesElement = document.querySelector(
      wrapperCategoriesElementSelector
    );
    this.genderButtonElements = document.querySelectorAll(
      buttonGenderMobileSelector
    );

    this.activeSubmenu = null;
  }

  open() {
    if (
      !hasClassElement(
        document.querySelector(selector.headerContent),
        classes.is.visible
      )
    ) {
      document.dispatchEvent(closeSearcherFromMenu); // Close Searcher if Menu Open
    }
    addClassToElement(this.wrapperElement, classes.is.visible);
    setHtmlUnscrollable();
  }

  close() {
    const contentElementTransitionDuration =
      parseFloat(
        getComputedStyle(this.wrapperElement).getPropertyValue(
          '--open-close-transition-duration'
        )
      ) * 1000;

    removeClassToElement(this.wrapperElement, classes.is.visible);
    setHtmlScrollable();
    setTimeout(() => {
      this.closeSubmenu();
    }, contentElementTransitionDuration);
  }

  selectGender(button) {
    addClassToElement(button, classes.is.active);
  }

  animateCategories() {
    const keyframe = [
      { transform: 'translateY(10px)', opacity: '0' },
      { transform: 'translateY(0px)', opacity: '1' }
    ];

    this.wrapperElement
      .querySelectorAll(`${selector.menuLink}`)
      .forEach((element) => {
        element.animate(keyframe, {
          duration: 250,
          easing: 'cubic-bezier(0.64, 0, 0.34, 1)',
          fill: 'both'
        });
      });
  }
}
